import CarePlansPage from "./pages/CarePlansPage";
import CarePlanCreationPage from "./pages/CarePlanCreationPage";
import CarePlansCard from "./components/cards/CarePlansCard";
import { Navigate } from "react-router-dom";

export const carePlansRoutes = [
  { path: "/care-plan", element: <CarePlansPage /> },
  { path: "/Careplan", element: <Navigate to="/care-plan" replace /> },
  { path: "/create-care-plan/:patientId", element: <CarePlanCreationPage /> },
  { path: "/care-plans/:patientId", element: <CarePlansCard /> },
  { path: "/IACarePlanPage", element: <Navigate to="/care-plan" replace /> },
];
